import React from "react";
import { RiSendPlane2Fill, RiStopFill } from "react-icons/ri";

interface Props {
  inputMessage: string;
  isStreaming: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  onInputChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onStop: () => void;
}

const ChatInput: React.FC<Props> = ({
  inputMessage,
  isStreaming,
  inputRef,
  onInputChange,
  onSubmit,
  onStop,
}) => (
  <div className="px-4 py-3 bg-white border-t border-gray-100 shrink-0">
    <form className="w-full flex items-center gap-2" onSubmit={onSubmit}>
      <input
        ref={inputRef}
        type="text"
        value={inputMessage}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder="Type your message..."
        disabled={isStreaming}
        className="flex-1 min-w-0 bg-gray-50 rounded-xl py-2.5 px-4 text-xs font-medium outline-none focus:ring-1 focus:ring-[#090F21] focus:border-[#090F21] border border-gray-200 transition-all placeholder:text-gray-400 shadow-inner disabled:opacity-60"
      />
      {isStreaming ? (
        <button
          type="button"
          onClick={onStop}
          aria-label="Stop generating response"
          className="shrink-0 !bg-red-600 text-white px-4 py-2.5 rounded-xl text-xs font-semibold flex items-center gap-1.5 hover:!bg-red-700 active:scale-95 transition-all shadow-md"
        >
          <RiStopFill size={13} />
          Stop
        </button>
      ) : (
        <button
          type="submit"
          disabled={!inputMessage.trim()}
          className="shrink-0 !bg-blue-600 text-white px-4 py-2.5 rounded-xl text-xs font-semibold flex items-center gap-1.5 hover:!bg-blue-700 active:scale-95 transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <RiSendPlane2Fill size={13} />
          Send
        </button>
      )}
    </form>
    <p className="text-center text-[9px] text-gray-400 mt-1.5 font-medium tracking-tight">
      Powered by Inception Financial
    </p>
  </div>
);

export default ChatInput;
